module.exports = __webpack_public_path__ + "img/why.bac092dd.png";